import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaDevices',
			dom: {
				slide: '.js-slider-slide',
				next: '#yotaDevicesNext',
				prev: '#yotaDevicesPrev'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.prevent = false;
		this.background = -9;
		return this;
	}

	getDom() {
		this.$slide = this.$el.find(this.options.dom.slide);
		this.$next = this.$el.find(this.options.dom.next);
		this.$prev = this.$el.find(this.options.dom.prev);
		return this;
	}

	dir(set) {
		const self = this;
		const active = set;
		const count = self.$slide.length;
		if (!self.prevent) {
			self.prevent = true;
			self.$slide.each(function () {
				const $this = $(this);
				const index = $this.index();
				let sets = index - active;
				if (sets < 3 - count || sets < 0) {
					sets += count;
				}
				$this
					.attr('data-old', $this.attr('data-position'))
					.attr('data-set', 'false')
					.attr('data-position', sets);

				setTimeout(function () {
					$this.attr('data-set', 'true');
				}, 5);
				setTimeout(function () {
					self.prevent = false;
				}, 505);
			});
		}
		return self;
	}

	onPrev() {
		let $active = this.$slide.filter('[data-position="0"]').prev();
		if (!$active.is(this.$slide)) {
			$active = this.$slide.last();
		}
		this.dir($active.index());
	}

	onNext() {
		let $active = this.$slide.filter('[data-position="0"]').next();
		if (!$active.is(this.$slide)) {
			$active = this.$slide.first();
		}
		this.dir($active.index());
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$prev.on('click', this.onPrev.bind(this));
			this.$next.on('click', this.onNext.bind(this));
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/devices/devices.js